var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.125 4.25H3.54167H14.875",
    stroke: "#222222",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4583 4.25001V14.1667C13.4583 14.5424 13.309 14.9027 13.0434 15.1684C12.7777 15.4341 12.4173 15.5833 12.0416 15.5833H4.95829C4.58257 15.5833 4.22223 15.4341 3.95656 15.1684C3.69088 14.9027 3.54163 14.5424 3.54163 14.1667V4.25001M5.66663 4.25001V2.83334C5.66663 2.45762 5.81588 2.09728 6.08156 1.8316C6.34723 1.56593 6.70757 1.41667 7.08329 1.41667H9.91663C10.2923 1.41667 10.6527 1.56593 10.9184 1.8316C11.184 2.09728 11.3333 2.45762 11.3333 2.83334V4.25001",
    stroke: "#222222",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove_icon.2ae1882862b6f7515750927ecf6f2dd1.svg";
export { ForwardRef as ReactComponent };